import { createReducer, on } from '@ngrx/store';

import { State } from '../models';

import * as actions from './customer-product-identifiers.actions';

export const customerProductIdentifiersFeatureKey =
  'customerProductIdentifiers';

export const initialState: State = {
  productExtensions: {},
  loading: false,
  loaded: false,
  error: null,
};

export const reducer = createReducer(
  initialState,

  on(actions.loadCustomerProductIdentifiers, (state) => {
    return { ...state, loading: true };
  }),
  on(actions.loadCustomerProductIdentifiersFailure, (state, { error }) => {
    return { ...state, error, loading: false };
  }),
  on(
    actions.loadCustomerProductIdentifiersSuccess,
    (state, { identifiers }) => {
      return {
        ...state,
        loading: false,
        loaded: true,
        productExtensions: identifiers.reduce((acc, curr) => {
          return {
            ...acc,
            [curr.productId]: {
              customerProductIdentifier: curr.accountProductId,
            },
          };
        }, {}),
      };
    },
  ),
);
